module.exports = __webpack_public_path__ + "img/p3.dfe0212c.png";